import { gql } from '@apollo/client'

import { StaffMemberFragment } from '../graphql/StaffMemberFragment'
import { StoreFragment } from '../graphql/StoreFragments'

export const AssignedStoresQuery = gql`
  ${StoreFragment}
  ${StaffMemberFragment}
  query MyAssignedStores($multiStore: Boolean!) {
    me {
      customer {
        store @skip(if: $multiStore) {
          ...Store
        }
        staff @skip(if: $multiStore) {
          ...StaffMember
        }
        stores @include(if: $multiStore) {
          store {
            ...Store
          }
          staffMember {
            ...StaffMember
          }
        }
        assignedStores @include(if: $multiStore) {
          storeId
          staffId
        }
      }
    }
  }
`
